import {
    AfterViewInit,
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges
} from '@angular/core';
import { Observable, of, ReplaySubject } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { EditGrid } from '../../../shared';
import { SelectItem } from '../../../shared/efaact-primeng.module';
import { LoggingService } from '../../../shared/services/logging/logging.service';
import { PayrollItem } from '../store';

@Component({
    selector: 'ef-payroll-item-association',
    templateUrl: './payroll-item-association.component.html',
    styleUrls: ['./payroll-item-association.component.scss'],
    standalone: false
})
export class PayrollItemAssociationComponent
    extends EditGrid<PayrollItem>
    implements OnInit, AfterViewInit, OnChanges {
    dropdownItemHeight = environment.dropdownItemHeight;
    @Input() payrollCodes: SelectItem[];
    @Input() payrollItemsSelectItems: SelectItem[];
    public availablePayrollItemsSubject = new ReplaySubject<SelectItem[]>(1);
    public hideNoPayrollCode = false;
    private HideNoPayrollSubject = new ReplaySubject<boolean>(1);
    public filteredItems$: Observable<PayrollItem[]>;

    constructor(private log: LoggingService) {
        super();
    }
    ngOnInit(): void {
        this.filteredItems$ = this.HideNoPayrollSubject.pipe(
            tap(hide =>
                this.log.verbose({
                    type: 'PayrollItemAssociationComponent:filteredItems$',
                    hide,
                    items: this.items
                })
            ),
            switchMap(hide =>
                hide
                    ? of(
                          this.items.filter(
                              x => !!x.ExportCode && x.ExportCode !== 'na'
                          )
                      )
                    : of(this.items)
            ),
            tap(items =>
                this.log.verbose({
                    type: 'PayrollItemAssociationComponent:filteredItems$',
                    items
                })
            )
        );
    }
    ngAfterViewInit(): void {
        setTimeout(() => {
            this.HideNoPayrollSubject.next(false);
        }, 100);
    }
    ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        if (
            changes &&
            changes.items &&
            changes.items.currentValue &&
            changes.items.currentValue.length > 0
        ) {
            this.HideNoPayrollSubject.next(false);
        }
    }
    onStatusClick(item: PayrollItem) {
        this.log.verbose({
            type: 'PayrollItemAssociationComponent:onStatusClick',
            item
        });
        this.ShowError.emit({ open: true, MsgEntityID: item.PIListID });
    }
    onRowEditInit(item: PayrollItem) {
        this.log.verbose({
            type: 'PayrollItemAssociationComponent:onRowEditInit',
            item
        });
        const current =
            item && item.id !== 'add'
                ? [{ label: item.PayrollItem, value: item.PIListID }]
                : [];
        this.availablePayrollItemsSubject.next(
            current.concat(
                this.items
                    .filter(x => !x.ExportCode)
                    .map(x => ({ label: x.PayrollItem, value: x.PIListID }))
            )
        );
        super.onRowEditInit(item);
    }
    hideNoPayrollCodeChanged($event) {
        this.log.verbose({
            type: 'PayrollItemAssociationComponent:hideNoPayrollCodeChanged',
            $event
        });
        this.HideNoPayrollSubject.next($event);
        // if ($event) {
        //     this.dataTable.filter(
        //         $event ? true : null,
        //         'ExportCode',
        //         'contains'
        //     );
        // } else {
        //     this.dataTable.filter('', 'ExportCode', 'contains');
        // }
    }
}
